import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControl,
  Select,
  MenuItem
} from '@material-ui/core';

const STATUS_TRANSITIONS = {
  available: ['Reservation Made','Used'],
  'reservation made': ['Available','Used'],
   'used': ['Available','Reservation Made']
};

const EditStatusModal = ({ open, onClose, status, onSave }) => {
  const currentStatus = status || '';
  const normalizedStatus = currentStatus.toLowerCase();

  const nextStatusOptions = STATUS_TRANSITIONS[normalizedStatus] || [];
  const [selectedStatus, setSelectedStatus] = useState('');

  const formatStatus = (status = '') =>
    status
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: { backgroundColor: '#ffffff', color: '#000000' }
      }}
      BackdropProps={{
        style: { backgroundColor: 'rgba(0,0,0,0.3)' }
      }}
    >
      <DialogTitle>Edit Status</DialogTitle>

      <DialogContent>
        <Typography variant="body1" style={{ marginBottom: 16 }}>
          <strong>Current Status:</strong> {formatStatus(currentStatus)}
        </Typography>

        <Typography variant="body1" style={{ marginBottom: 8 }}>
          <strong>Change Status:</strong>
        </Typography>

        <FormControl variant="outlined" fullWidth>
          <Select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            displayEmpty
            MenuProps={{
              PaperProps: {
                style: {
                  backgroundColor: '#ffffff',
                  color: '#000000'
                }
              }
            }}
            renderValue={(value) =>
    value ? formatStatus(value) : 'Select status'
  }
          >
            {nextStatusOptions.map((option) => (
              <MenuItem key={option} value={option.toLowerCase()}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions>
        <Button onClick={()=>{
            setSelectedStatus('')
            onClose()
            }}>Cancel</Button>
        <Button
          onClick={() => {
            onSave(selectedStatus)
            setSelectedStatus('')
        }}
          color="primary"
          variant="contained"
          disabled={!selectedStatus}
            style={{
    backgroundColor: !selectedStatus ? '#e0e0e0' : '#3f51b5',
    color: !selectedStatus ? '#9e9e9e' : '#ffffff',
    cursor: !selectedStatus ? 'not-allowed' : 'pointer'
  }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditStatusModal;
